var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card mt-3", attrs: { "header-bg-variant": "white" } },
    [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col" }, [
            _c("h5", { attrs: { "data-test-hook": "plan-cost-header-text" } }, [
              _vm._v(" " + _vm._s(_vm.$t("xDealerManaged")) + " ")
            ])
          ])
        ]),
        _c("div", { staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "span",
              { attrs: { "data-test-hook": "plan-cost-header-text" } },
              [_vm._v(" " + _vm._s(_vm.$t("xPlanStatus")) + " ")]
            )
          ])
        ]),
        _c("div", { staticClass: "row mb-4" }, [
          _c("div", { staticClass: "col" }, [
            _c("strong", { attrs: { "data-test-hook": "plan-cost" } }, [
              _vm._v(
                " " +
                  _vm._s(_vm.productDealerManaged.apparatusName) +
                  " " +
                  _vm._s(_vm.$t("xIsManagedByYourDealer")) +
                  " "
              )
            ])
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "accordion",
            staticStyle: { width: "100%" },
            attrs: { role: "tablist" }
          },
          [
            _c(
              "div",
              {
                staticClass: "accordion-wrapper",
                staticStyle: {
                  border: "1px solid lightgrey",
                  padding: "10px",
                  "border-radius": "10px"
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle",
                        value:
                          "collapse-dealerManaged-" +
                          _vm.productDealerManaged.apparatusId,
                        expression:
                          "'collapse-dealerManaged-' + productDealerManaged.apparatusId"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row align-items-center no-gutters" },
                      [
                        _c("div", { staticClass: "col align-items-center" }, [
                          _c("i", {
                            staticClass: "fa-regular fa-circle-info pr-2"
                          }),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("xProductsAndFeatures")))
                          ])
                        ]),
                        _vm._m(0)
                      ]
                    )
                  ]
                ),
                _c(
                  "b-collapse",
                  {
                    attrs: {
                      id:
                        "collapse-dealerManaged-" +
                        _vm.productDealerManaged.apparatusId
                    }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("hr", { staticClass: "mx-0 px-0" })
                      ])
                    ]),
                    _c("div", { staticClass: "row mb-2" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", { staticClass: "mb-0 pb-0" }, [
                          _c(
                            "strong",
                            {
                              attrs: {
                                "data-test-hook": "products-included-text"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("xProductsCoveredByDM")) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col d-flex align-items-center" },
                        [
                          _c("b-img", {
                            staticClass: "mr-2",
                            attrs: {
                              src: _vm.getApparatusIcon(
                                _vm.productDealerManaged.apparatusType
                              )
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.productDealerManaged.apparatusName)
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row mt-3 mb-2" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", { staticClass: "mb-0 pb-0" }, [
                          _c(
                            "strong",
                            {
                              attrs: {
                                "data-test-hook": "products-included-text"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("xFeaturesIncludedInDM")) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm.productDealerManaged.apparatusType ===
                    _vm.hsbApparatusType
                      ? _c("div", [
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col d-flex align-items-center" },
                              [
                                _c("b-img", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src: require("@/assets/images/generator.svg")
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-test-hook": "features-included-list"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("xFeaturesInDMHsb1")) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col icon-and-text" }, [
                              _c("i", {
                                staticClass: "far fa-fw fa-circle-check mr-1"
                              }),
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-test-hook":
                                      "features-included-monitor-list"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "xFeaturePremiumMonitoringForOneHsb"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm.productDealerManaged.apparatusType ===
                    _vm.fuelTankApparatusType
                      ? _c("div", [
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "div",
                              { staticClass: "col d-flex align-items-center" },
                              [
                                _c("b-img", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src: require("@/assets/images/tank.svg")
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-test-hook": "features-included-list"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "xSubFeaturesFmFuelLevelHistoryWarningsBattery"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c("div", { staticClass: "col icon-and-text" }, [
                              _c("i", {
                                staticClass: "far fa-fw fa-circle-check mr-1"
                              }),
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-test-hook":
                                      "features-included-monitor-list"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("xSubFeaturesFmMonitorOneFm")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-warning mt-3",
            attrs: {
              type: "button",
              "data-test-hook": "openSubscribePremiumMonitoringBtn"
            },
            on: {
              click: function($event) {
                return _vm.openDealerInfo(_vm.productDealerManaged.apparatusId)
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("xViewDealerInformation")) + " ")]
        )
      ]),
      _vm.productDealerManaged && _vm.productDealerManaged.dealerInfo
        ? _c("DealerManagedContactModal", {
            attrs: {
              modalId: `contact-dealer-modal-${_vm.productDealerManaged.apparatusId}`,
              dealerInfo: _vm.productDealerManaged.dealerInfo
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-auto" }, [
      _c("i", { staticClass: "fas fa-chevron-down when-closed" }),
      _c("i", { staticClass: "fas fa-chevron-up when-open" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }